import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  const milestones = [
    { 
      year: '2005', 
      title: t('about.timeline.2005.title'), 
      description: t('about.timeline.2005.desc')
    },
    { 
      year: '2010', 
      title: t('about.timeline.2010.title'), 
      description: t('about.timeline.2010.desc')
    },
    { 
      year: '2015', 
      title: t('about.timeline.2015.title'), 
      description: t('about.timeline.2015.desc')
    },
    { 
      year: '2020', 
      title: t('about.timeline.2020.title'), 
      description: t('about.timeline.2020.desc')
    },
    { 
      year: '2025', 
      title: t('about.timeline.2025.title'), 
      description: t('about.timeline.2025.desc')
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              {t('about.subtitle')}
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {t('about.description')}
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">{t('about.stat1.value')}</div>
                <div className="text-gray-700 font-medium">{t('about.stat1.label')}</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">{t('about.stat4.value')}</div>
                <div className="text-gray-700 font-medium">{t('about.stat4.label')}</div>
              </div>
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">{t('about.stat3.value')}</div>
                <div className="text-gray-700 font-medium">{t('about.stat3.label')}</div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6">
                <div className="text-4xl font-bold text-orange-600 mb-2">{t('about.stat2.value')}</div>
                <div className="text-gray-700 font-medium">{t('about.stat2.label')}</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-teal-100 rounded-full opacity-50 blur-3xl"></div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-orange-100 rounded-full opacity-50 blur-3xl"></div>
            
            <div className="relative bg-white rounded-3xl shadow-2xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-8">{t('about.timeline.title')}</h3>
              
              <div className="space-y-8">
                {milestones.map((milestone, index) => (
                  <div key={index} className="flex gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center text-white font-bold">
                        {milestone.year}
                      </div>
                    </div>
                    <div className="flex-1 pt-2">
                      <h4 className="text-lg font-bold text-gray-900 mb-1">{milestone.title}</h4>
                      <p className="text-gray-600">{milestone.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
